
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.wixstatic.com/media/28b0ae19f137491787303790a4bd3284.jpg/v1/fill/w_1280,h_1016,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/28b0ae19f137491787303790a4bd3284.jpg"
          alt="Modern House"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-8 lg:px-12 text-center py-24 sm:py-20">
        <h1 className="text-2xl sm:text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-5 sm:mb-6 leading-tight">
          Your neighbours who<br />happen to be really good at<br />renovations and builds.
        </h1>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/95 mb-4 sm:mb-4 max-w-3xl mx-auto leading-relaxed">
          Renoboys offer commercial and residential builds, remodels, repairs, add-ons and more. If you can dream it, we can build it.
        </p>
        <p className="text-base sm:text-base md:text-lg text-orange-500 mb-10 sm:mb-10 font-medium">
          ...with quality you can see and renovations you can trust.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-4 max-w-md sm:max-w-none mx-auto">
          <button
            onClick={scrollToContact}
            className="bg-orange-500 text-white px-8 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-base font-semibold hover:bg-orange-600 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Get Your Free Quote
          </button>
          <button
            onClick={scrollToServices}
            className="bg-white/10 backdrop-blur-sm text-white px-8 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-base font-semibold hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            View Our Services
          </button>
        </div>
      </div>
    </section>
  );
}
